<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 0px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-folder</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.dfiles') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>      
    </v-toolbar>    
    <!-- <v-layout wrap v-show="!collapseContent">
      <v-flex xs12>
        <translate
          v-model="content.DropdownButtonTitle"
          :languages="languages"
          :label="$t('menuType.text')"
          @input="handleChangeIsModified"
          style="padding: 0 10px 0 10px;"
        />
      </v-flex>
      <v-flex xs3>
        <div
          class="text-left"
          style="margin-top: 10px"
        >
          {{ $t('dropdownButton.colors') }}
        </div>
      </v-flex>
      <v-flex xs9>
        <custom-color-picker-background-and-text
          style="width: 100px;"
          :BGColor="content.DropdownButtonBGColor"
          :TextColor="content.DropdownButtonTextColor"
          :onChangeColor="handleChangeCustomMenuColor"
        />
      </v-flex>
      <v-flex xs12>
      </v-flex>
    </v-layout> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Translate from '@/components/Translate'
  // import FormContentItem from './FormContentItem'
  import CustomColorPickerBackgroundAndText from '@/components/CustomColorPickerBGAndText'
  import ComponentInLine from '../../ComponentInLine'
  export default {
    components: {
      Translate,
      CustomColorPickerBackgroundAndText,
      ComponentInLine,
      // FormContentItem
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent', 'ColorContent']),
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    methods: {
      handleChangeIsModified () {
      },
      handleChangeCustomMenuColor (BGColor, TextColor) {
        this.content.DropdownButtonBGColor = BGColor
        this.content.DropdownButtonTextColor = TextColor
        this.handleChangeIsModified()
      },
      handleAddContent (){
      },
      handleMoveDisabled (value) {
        this.moveDisabled = value
      }
    }
  }
</script>

<style scoped>
</style>

